import { WS } from "./wsInit";

// import socketConfig from "../../../config/edelWebSockets/socketConfig";

//initalize the event listeners of the web socket
export function initWS<T>(req: T, sendToSrc: CallableFunction) {
	let msgReadyToSend: boolean = false;

	const waitingForConn = setInterval(() => {
		if (!msgReadyToSend && WS.readyState === 1) {
			WS.send(JSON.stringify(req) + "\n");
			msgReadyToSend = true;
		} else {
			clearInterval(waitingForConn);
		}
	}, 100);

	//heart beat pinged every two minutes to keep the socket connection alive, not related to request
	setInterval(() => {
		if (WS.readyState === 1) WS.send(JSON.stringify({}) + "\n");
	}, 120000);

	WS.onopen = (_e) => {
		try {
			// WS.readyState
			if (WS.readyState === 1 && !msgReadyToSend) {
				WS.send(JSON.stringify(req) + "\n");
				msgReadyToSend = true;
			}
		} catch (e) {
			console.log(e);
		}
	};

	WS.onmessage = (e: any) => {
		sendToSrc(e.data, "message");
	};

	WS.onerror = (e) => {
		sendToSrc(e, "error");
	};

	WS.onclose = (e) => {
		sendToSrc(e, "close");
	};
}

//to close webscoket connection from client end
export function closeEdelSocketConn() {
	WS.close();
}
